import Swiper from 'swiper';

const partnerSwiper = {
	init: function() {
		const partnersList = document.querySelector(".footerPartners__list");
		if( partnersList ){
			this.swiperObj = new Swiper(
				partnersList,
				{
					slidesPerView: 'auto',
					spaceBetween: 65,
					breakpoints: {
						940: {
							spaceBetween: 0,
						}
					}
				}
			);
		}
	},
};

export default partnerSwiper;